export const tutorialCssConstants = {
   initialHeightLandscape: 100,
   initialHeightPortrait: 185,

   desktopMinWidth: 250,
   desktopMaxWidth: 500,
};
